<template>
	<div :id="baseId" class="creators-showcase-panel d-flex flex-column">
		<div class="creators-showcase-panel-carousel d-flex flex-column">
			<div class="slide_header">
				<h1>The Best Creators Use Stan 🚀</h1>
				<h2>See how our creators use Stan to superpower their businesses!</h2>
			</div>

			<div class="scroll">
				<div class="highlight">
					<div class="img" :style="{ 'background-image': 'url(' + require('@/assets/images/home/v6/abi.png') + ')' }">
						<div class="expo anim">
							<h1>Abigail Peugh</h1>
							<h2>@abigailpeugh</h2>
							<div class="social">
								<img src="@/assets/images/home/v6/tt.svg" alt="Instagram" />
								<h4>100K+ Followers</h4>
							</div>
							<h3>💰 <span>.</span> Business Coach</h3>
						</div>
					</div>
					<a href="https://stan.store/abigailpeugh">
						<img class="store anim" src="@/assets/images/home/v6/creatorHighlights/store-abi.png" alt="store" />
					</a>
				</div>

				<div class="highlight">
					<div class="img" :style="{ 'background-image': 'url(' + require('@/assets/images/home/v6/millie.jpg') + ')' }">
						<div class="expo anim">
							<h1>Millie Adrian</h1>
							<h2>@itsmodernmillie</h2>
							<div class="social">
								<img src="@/assets/images/home/v6/ig.svg" alt="Instagram" />
								<h4>150K+ Followers</h4>
							</div>
							<h3>📲 <span>.</span> Social Media Coach</h3>
						</div>
					</div>
					<a href="https://stan.store/itsmodernmillie">
						<img class="store anim" src="@/assets/images/home/v6/creatorHighlights/store-millie.png" alt="store" />
					</a>
				</div>

				<div class="highlight">
					<div class="img" :style="{ 'background-image': 'url(' + require('@/assets/images/home/v6/eddie.png') + ')' }">
						<div class="expo anim">
							<h1>Eddie Abbew</h1>
							<h2>@eddieabbew</h2>
							<div class="social">
								<img src="@/assets/images/home/v6/ig.svg" alt="Instagram" />
								<h4>554K+ Followers</h4>
							</div>
							<h3>💪 <span>.</span> Fitness Coach</h3>
						</div>
					</div>
					<a href="https://stan.store/eddieabbew">
						<img class="store anim" src="@/assets/images/home/v6/store-eddie.svg" alt="store" />
					</a>
				</div>

				<div class="highlight">
					<div class="img" :style="{ 'background-image': 'url(' + require('@/assets/images/home/v6/priest.png') + ')' }">
						<div class="expo anim">
							<h1>Sarah Perl</h1>
							<h2>@hothighpriestess</h2>
							<div class="social">
								<img src="@/assets/images/home/v6/tt.svg" alt="Instagram" />
								<h4>2.4M+ Followers</h4>
							</div>
							<h3>✨ <span>.</span> Spirituality Creator</h3>
						</div>
					</div>
					<a href="https://stan.store/hothighpriestess">
						<img class="store anim" src="@/assets/images/home/v6/creatorHighlights/store-priestess.png" alt="store" />
					</a>
				</div>

				<div class="highlight">
					<div class="img" :style="{ 'background-image': 'url(' + require('@/assets/images/home/v6/tat.jpg') + ')' }">
						<div class="expo anim">
							<h1>Tatiana Londono</h1>
							<h2>@tatlondono</h2>
							<div class="social">
								<img src="@/assets/images/home/v6/tt.svg" alt="Instagram" />
								<h4>2.8M+ Followers</h4>
							</div>
							<h3>🏠 <span>.</span> Real Estate Coach</h3>
						</div>
					</div>
					<a href="https://www.tiktok.com/@tatlondono">
						<img class="store anim" src="@/assets/images/home/v6/creatorHighlights/store-tat.png" alt="profile" />
					</a>
				</div>

				<div class="highlight">
					<div class="img" :style="{ 'background-image': 'url(' + require('@/assets/images/home/v6/thea.webp') + ')' }">
						<div class="expo anim">
							<h1>Thea Wayne</h1>
							<h2>@moneyhealingclub</h2>
							<div class="social">
								<img src="@/assets/images/home/v6/ig.svg" alt="Instagram" />
								<h4>3K+ Followers</h4>
							</div>
							<h3>💰 <span>.</span> Finance Coach</h3>
						</div>
					</div>
					<a href="https://www.tiktok.com/@moneyhealingclub">
						<img class="store anim" src="@/assets/images/home/v6/creatorHighlights/store-healing.png" alt="profile" />
					</a>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import { computed, defineComponent, getCurrentInstance, onMounted, ref, watch } from 'vue'
	//import { Swiper, SwiperSlide } from 'swiper/vue'
	import { Navigation } from 'swiper'
	import 'swiper/css/navigation'
	import 'swiper/css'

	const carouselBreakpoints = {
		0: {
			slidesPerView: 2,
			spaceBetween: 10,
		},
		395: {
			slidesPerView: 2.1,
			spaceBetween: 10,
		},
		410: {
			slidesPerView: 2.3,
			spaceBetween: 10,
		},
		443: {
			slidesPerView: 2.5,
			spaceBetween: 10,
		},
		474: {
			slidesPerView: 2.7,
			spaceBetween: 10,
		},
		516: {
			slidesPerView: 2.9,
			spaceBetween: 10,
		},
		619: {
			slidesPerView: 3.1,
			spaceBetween: 10,
		},
		668: {
			slidesPerView: 3.3,
			spaceBetween: 10,
		},
		698: {
			slidesPerView: 3.5,
			spaceBetween: 10,
		},
		768: {
			slidesPerView: 3.2,
			spaceBetween: 10,
		},
		992: {
			slidesPerView: 4.5,
			spaceBetween: 25,
		},
		1024: {
			slidesPerView: 5.2,
			spaceBetween: 30,
		},
		1597: {
			slidesPerView: 5.5,
			spaceBetween: 30,
		},
		1600: {
			slidesPerView: 6.4,
			spaceBetween: 80,
		},
	}

	const creators = [
		{
			handle: 'coach.stone',
			followers: '243.2k',
			niche: '🚀 Social Media Coach',
			image: '@/assets/images/home/v6/creators/coach_stone',
			url: 'https://stan.store/stonefredrickson',
			products: [
				{ title: 'Courses', icon: '/images/home/v4/icons/courses.svg' },
				{ title: 'Bookings', icon: '/images/home/v4/icons/bookings.svg' },
				{ title: 'Digital Downloads', icon: '/images/home/v4/icons/digital-downloads.svg' },
			],
			backgroundColor: '#F6F7FF',
			nicheColor: '#FF9170',
		},
		{
			handle: 'sociallykels',
			followers: '354.4k',
			niche: '🚀 Social Media Coach',
			image: '@/assets/images/home/v6/creators/sociallykels',
			url: 'https://stan.store/sociallykels',
			products: [
				{ title: 'Courses', icon: '/images/home/v4/icons/courses.svg' },
				{ title: 'Bookings', icon: '/images/home/v4/icons/bookings.svg' },
				{ title: 'Digital Downloads', icon: '/images/home/v4/icons/digital-downloads.svg' },
			],
			backgroundColor: '#F6F7FF',
			nicheColor: '#FF9170',
		},
		{
			handle: 'tatlondono',
			followers: '2.7m',
			niche: '🏠 Real Estate Coach',
			image: '@/assets/images/home/v6/creators/tatlondono',
			url: 'https://stan.store/tatlondono',
			products: [
				{ title: 'Courses', icon: '/images/home/v4/icons/courses.svg' },
				{ title: 'Bookings', icon: '/images/home/v4/icons/bookings.svg' },
				{ title: 'Digital Downloads', icon: '/images/home/v4/icons/digital-downloads.svg' },
			],
			backgroundColor: '#F6F7FF',
			nicheColor: '#FF9170',
		},
		{
			handle: 'melefante6',
			followers: '754.2k',
			niche: '🏨 AirBnB Coach',
			image: '@/assets/images/home/v6/creators/melefante6',
			url: 'https://stan.store/melefante6',
			products: [
				{ title: 'Courses', icon: '/images/home/v4/icons/courses.svg' },
				{ title: 'Bookings', icon: '/images/home/v4/icons/bookings.svg' },
				{ title: 'Digital Downloads', icon: '/images/home/v4/icons/digital-downloads.svg' },
			],
			backgroundColor: '#F6F7FF',
			nicheColor: '#FF9170',
		},
		{
			handle: 'latha_jay',
			followers: '452k',
			niche: '🌙 Spiritual Coach',
			image: '@/assets/images/home/v6/creators/latha_jay',
			url: 'https://stan.store/LathaJay',
			products: [
				{ title: 'Courses', icon: '/images/home/v4/icons/courses.svg' },
				{ title: 'Bookings', icon: '/images/home/v4/icons/bookings.svg' },
				{ title: 'Digital Downloads', icon: '/images/home/v4/icons/digital-downloads.svg' },
			],
			backgroundColor: '#F6F7FF',
			nicheColor: '#FF9170',
		},
		{
			handle: 'ComfyGirlCurls',
			followers: '17.9k',
			niche: '🚀 Social Media Coach',
			image: '@/assets/images/home/v6/creators/ComfyGirlCurls',
			url: 'https://stan.store/creatingwithkaya',
			products: [
				{ title: 'Courses', icon: '/images/home/v4/icons/courses.svg' },
				{ title: 'Bookings', icon: '/images/home/v4/icons/bookings.svg' },
				{ title: 'Digital Downloads', icon: '/images/home/v4/icons/digital-downloads.svg' },
			],
			backgroundColor: '#F6F7FF',
			nicheColor: '#FF9170',
		},
	]

	export default defineComponent({
		name: 'LandingV6CreatorShowcase',
		components: {
			//Swiper,
			//SwiperSlide,
		},
		props: {
			id: {
				type: [String, Number],
			},
			activeComponent: { type: Boolean },
		},
		setup(props) {
			const creatorCarouselRef = ref(null)
			const currentCreatorSlideIndex = ref(null)

			const creatorsList = computed(() => {
				const c = creators.map(c => {
					let data = { ...c }
					data.imageCard = `${c.image}_card.webp`
					data.image = `${c.image}.webp`
					return data
				})
				return [...c, ...c, ...c]
			})

			const updateSlideIndex = index => {
				currentCreatorSlideIndex.value = index
				document.documentElement.style.setProperty(
					'--stan-creator-section-background',
					creatorsList.value[currentCreatorSlideIndex.value].backgroundColor
				)
				document.documentElement.style.setProperty(
					'--stan-creator-section-niche',
					creatorsList.value[currentCreatorSlideIndex.value].nicheColor
				)
				document.documentElement.style.setProperty(
					'--stan-creator-section-products',
					creatorsList.value[currentCreatorSlideIndex.value].nicheColor
				)
			}

			const goTo = url => {
				window.open(url, '_blank')
			}

			return {
				baseId: `${props.id}`,
				addonId: `${props.id}-add-on`,
				creatorCarouselRef,
				carouselBreakpoints,
				goTo,
				currentCreatorSlideIndex,
				creatorsList,
				modules: [Navigation],
			}
		},
	})
</script>

<style lang="scss" scoped>
	.creators-showcase-panel {
		background: white;
		top: -1px;
		position: relative;
	}

	.slide_header {
		image-rendering: -webkit-optimize-contrast;
		text-align: center;
		margin-bottom: 60px;
		margin-top: 60px;

		h1 {
			font-size: 36px;
			font-weight: 900;
			margin-bottom: 30px;
		}
		h2 {
			font-size: 18px;
			font-weight: 400;
		}
	}

	.scroll {
		display: flex;
		gap: 0px;
		overflow-y: hidden;
		overflow-x: scroll;
		padding: 80px 30px 120px 100px;
		-ms-overflow-style: none; /* IE and Edge */
		scrollbar-width: none; /* Firefox */
		&::-webkit-scrollbar {
			display: none;
		}
	}

	.highlight {
		display: flex;
		align-items: center;
		margin-right: -25px;

		&:nth-child(even) {
			transform: translateY(var(--parallax-s1-1));
		}

		&:nth-child(odd) {
			transform: translateY(var(--parallax-s1-2));
		}

		&.final {
			padding-right: 100px;
		}

		.img {
			height: 400px;
			width: 400px;
			border-radius: 15px;
			box-shadow: -10px 10px 30px rgba(black, 0.1);
			background-position: center center;
			background-size: cover;
			position: relative;
		}
		.expo {
			position: absolute;
			bottom: 0;
			left: 0;
			color: white;
			border-radius: 15px;
			width: 340px;
			padding: 25px;
			background-image: linear-gradient(to top, rgba(black, 0.7), rgba(black, 0));
			.social {
				display: flex;
				align-items: center;
				gap: 6px;
				margin-left: 1px;
				margin-bottom: 12px;
				img {
					height: 13px;
				}
				h4 {
					color: white;
					font-weight: 500;
					font-size: 12px;
					line-height: 10px;
					margin-top: 7px;
				}
			}

			h1 {
				font-size: 24px;
				font-weight: 700;
				margin-bottom: 6px;
				text-shadow: 0px 20px 30px rgba(black, 0.9);
			}

			h2 {
				font-size: 14px;
				font-weight: 500;
				color: rgba(white, 0.6);
				margin-bottom: 6px;
				text-shadow: 0px 20px 30px rgba(black, 0.9);
			}

			h3 {
				font-size: 13px;
				font-weight: 700;
				background: white;
				color: black;
				padding: 10px 13px;
				width: fit-content;
				border-radius: 50px;

				span {
					color: white;
				}
			}
		}
	}

	.profile {
		width: 230px;
		border-radius: 20px;
		box-shadow: 0px 20px 60px rgba(#00106d, 0.1);
	}
	.store {
		width: 220px;
		border-radius: 40px;
		box-shadow: -10px 10px 30px rgba(black, 0.1);
		z-index: 5 !important;
		transform: translateX(-100px);
	}

	.slide_highlight {
		padding-bottom: 0;
		background-color: none;
	}

	.slide_carousel {
		display: flex;
		justify-content: center;
		align-items: center;
		text-align: center;
		background: none;
		padding: 120px 0;
		gap: 50px;

		.stat {
			width: 240px !important;
			height: 240px !important;
			background: #f5f5f5;
			border-radius: 50%;

			display: flex;
			flex-direction: column;
			align-items: center;
			justify-content: center;

			&:nth-child(1) {
				transform: translateY(var(--parallax-s3-1));
			}

			&:nth-child(2) {
				transform: translateY(var(--parallax-s3-2));
			}

			&:nth-child(3) {
				transform: translateY(var(--parallax-s3-2));
			}

			&.big {
				width: 280px !important;
				height: 280px !important;
			}

			h1 {
				font-size: 80px;
				font-weight: 900;
				margin: 0;
			}

			h2 {
				font-size: 40px;
				font-weight: 900;
				margin: 0;
			}

			h3 {
				font-size: 16px;
				font-weight: 400;
				letter-spacing: -0.2px;
				margin: 0;
				margin-top: 15px;
			}
		}
	}

	@media screen and (max-width: 800px) {
		.slide_header {
			text-align: center;
			width: 85%;
			margin: auto;
			padding-top: 40px;
			margin-bottom: -30px;
			h1 {
				font-size: 20px;
				font-weight: 900;
				margin-bottom: 15px;
			}
			h2 {
				font-size: 14px;
				line-height: 150%;
				font-weight: 400;
			}
		}

		.slide_carousel {
			display: flex;
			flex-direction: column;
			.stat {
			}
		}
	}

	@media screen and (max-width: 800px) {
		.scroll {
			padding-left: 80px !important;
		}
		.highlight {
			margin-left: -50px;
			.expo {
				width: 70vw;
				padding: 20px;
			}
			.img {
				width: 70vw;
				height: 70vw;
				.expo {
					padding: 20px;
					h1 {
						font-size: 22px;
						margin-bottom: 5px;
					}
					h2 {
						margin-bottom: 10px;
					}
				}
			}
			.store {
				width: 30vw;
				margin-left: 50px;
				border-radius: 20px;
				width: 30vw;
				margin-left: 50px;
				border-radius: 20px;
			}
		}
	}
</style>
